import React from "react";

import { ListLayoutProps } from "@companion-core/shared/app/Interfaces/blocks";
import { ComponentData } from "@companion-core/shared/app/Interfaces/API";
import { ComponentCard } from "@companion-core/shared/app/Components/Cards/ComponentCard";
import { SkeletonCard } from "@companion-core/shared/app/Components/Cards/SkeletonCard/SkeletonCard";
import { NoResultPage } from "@companion-core/shared/app/Components/NoResultPage";
import { Filters } from "@companion-core/shared/app/Components/Filters";
import { useDynamicPageStore } from "@companion-core/shared/app/Store/dynamicPageStore";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { useFiltersStore } from "@companion-core/shared/app/Store/filters";

import "@companion-core/web/src/Assets/Styles/scss/listLayout.scss";

const ListLayoutMultipleSkeleton = (): React.JSX.Element => {
  return (
    <div data-testid="list-layout__skeleton--multiple" className="list-layout__skeleton">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
};

const ListLayoutSingleSkeleton = () => {
  return (
    <div data-testid="list-layout__skeleton--single" className="list-layout__skeleton">
      <SkeletonCard />
    </div>
  );
};

export const ListLayout = ({
  title,
  queryComponents,
  isPending = false,
  blockItemId,
  withFilters,
  withSearchBar,
  withGeolocalisation,
  filters,
}: ListLayoutProps) => {
  const { pageSlug } = useDynamicPageStore();
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const { resetFilters } = useFiltersStore();
  const listLayoutSkeleton =
    !isMobileSize || !queryComponents?.length ? (
      <ListLayoutMultipleSkeleton />
    ) : (
      <ListLayoutSingleSkeleton />
    );

  return (
    <div className="list-layout__container">
      {(withFilters || withSearchBar) && (
        <Filters
          withSearchBar={withSearchBar}
          testID={`filters-${blockItemId}`}
          filters={filters}
          withGeolocalisation={withGeolocalisation}
        />
      )}

      <section data-testid={`list-layout--${blockItemId}`} className="list-layout">
        <h1
          data-testid={`list-layout__title--${blockItemId}`}
          className="list-layout__title super-title-3">
          {title}
        </h1>
        {isPending ? (
          listLayoutSkeleton
        ) : (
          <>
            {queryComponents?.length > 0 && (
              <div
                data-testid={`list-layout__content--${blockItemId}`}
                className="list-layout__content">
                {queryComponents.map((item: ComponentData, index: number) => (
                  <ComponentCard
                    key={`list-layout-card-${item.id}`}
                    component={item}
                    pageSlug={pageSlug ?? ""}
                    nbItems={queryComponents.length}
                    position={index}
                    url={window.location.href}
                    blockItemId={blockItemId}
                    fixedHeight={true}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </section>
      {!isPending && queryComponents?.length === 0 && (
        <NoResultPage blockItemID={blockItemId ?? ""} resetSearch={() => resetFilters()} />
      )}
    </div>
  );
};
